import { Module } from "vuex";
import { RootState } from "@/store/types";
import { smsStatistic } from "@/store/sms/statistic";
import { smsTemplate } from "@/store/sms/templates";
import { smsFilter } from "@/store/sms/filters";
import { restrictions } from "@/store/sms/restrictions";

export const smsModule: Module<any, RootState> = {
  modules: {
    smsStatistic,
    smsTemplate,
    smsFilter,
    restrictions,
  },
};
